"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.actionFor = exports.action = exports.lastAction = void 0;
const index_js_1 = require("../task/index.js");
exports.lastAction = Symbol();
let doAction = (store, actionName, cb, args) => {
    let tracker = { ...store };
    tracker.set = (...setArgs) => {
        store[exports.lastAction] = actionName;
        store.set(...setArgs);
        delete store[exports.lastAction];
    };
    if (store.setKey) {
        tracker.setKey = (...setArgs) => {
            store[exports.lastAction] = actionName;
            store.setKey(...setArgs);
            delete store[exports.lastAction];
        };
    }
    let result = cb(tracker, ...args);
    if (result instanceof Promise) {
        let endTask = (0, index_js_1.startTask)();
        return result.finally(endTask);
    }
    return result;
};
let action = (store, actionName, cb) => (...args) => doAction(store, actionName, cb, args);
exports.action = action;
let actionFor = (Template, actionName, cb) => {
    return (store, ...rest) => doAction(store, actionName, cb, rest);
};
exports.actionFor = actionFor;
